let selfReloadingScreens = 0;
const listeners = new Set<() => void>();

const notifyListeners = () => listeners.forEach(listener => listener());

export const registerSelfReloadingScreen = () => {
  selfReloadingScreens += 1;
  notifyListeners();

  return () => {
    selfReloadingScreens -= 1;
    notifyListeners();
  };
};

export const subscribeToSelfReloadingScreens = (listener: () => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const hasSelfReloadingScreen = () => selfReloadingScreens > 0;
